import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/checklists/")({
  head: () => buildRouteHead("/es/checklists", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/downloads/checklists", replace: true });
  },
});
